import React from "react";

import p9 from "../../../assets/img/p9i9wsc0r9st4kofjmbd.jpg";
import { TiTick } from "react-icons/ti";
import { Link } from "react-router-dom";
function AboutStory({ data, t }) {
  return (
    <>
      <div className="aboutSection">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="fisherman-content">
                
                <h3 className="subtitle">
                  {t("About GGAS Maintenance Tooling & Equipments ")}
                </h3>

                <p>
                  GGAS Aviation Services stands at the forefront of the aviation
                  industry as a trusted provider of GGAS maintenance products
                  and expert consultancy. Combining innovation with decades of
                  hands-on experience, we deliver a comprehensive range of
                  solutions designed to enhance and streamline GGAS maintenance
                  operations.
                </p>
                <p>
                  Our broad portfolio supports every phase of the maintenance
                  lifecycle, offering reliable, cost-efficient products and
                  services tailored to meet the evolving needs of airlines and
                  MROs. Backed by a skilled, well-trained team, we ensure high
                  service standards, operational excellence, and on-time
                  performance in every engagement.
                </p>
                <p>
                  As the industry’s only true Turnkey provider, we specialize in
                  delivering complete end-to-end aviation maintenance
                  solutions—from design, production, and procurement to supply
                  chain coordination, installation, testing, and final
                  commissioning.
                </p>
                <p>
                  Through our commitment to safety, innovation, and a
                  knowledge-driven approach, GGAS Aviation Services continues to
                  serve all segments of the aviation sector with tailored,
                  high-performance solutions that drive operational success.
                </p>
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutStory;
